import { SearchTerm } from "./SearchTerm";

const OperationalComplianceReportSearch: SearchTerm[] = [
    {
        heading: "All",
        accessor: "search",
        searchOnName: "search",
        translationKey: "all"
    },
    {
        heading: "Display Name",
        accessor: "displayName",
        searchOnName: "mstDisplayname",
        translationKey: "displayName"
    }, 
    {
        heading: "First Name",
        accessor: "firstName",
        searchOnName: "mstFirstname",
        translationKey: "firstName",
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        searchOnName: "mstLastname",
        translationKey: "lastName",
    },
    {
        heading: "Unique Identifier",
        accessor: "uid",
        searchOnName: "mstIdnumber",
        translationKey: "uniqueIdentifier"
    }
]

export default OperationalComplianceReportSearch;
